import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=a2920de0&"
import script from "./Redirect.vue?vue&type=script&lang=ts&"
export * from "./Redirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports